export function reveal(): void {
  const reveals = document.querySelectorAll(".reveal")

  for (let i = 0; i < reveals.length; i++) {
    const windowHeight = window.innerHeight
    const elementTop = reveals[i].getBoundingClientRect().top
    const elementVisible = 20

    if (elementTop < windowHeight - elementVisible) {
      reveals[i].classList.add("active")
    } else {
      reveals[i].classList.remove("active")
    }
  }
}

// Video background fade animation utility
export function createVideoFadeController(
  threshold: number = 200,
  fadeDistance: number = 300
) {
  return (scrollY: number, initialOpacity: number = 1): number => {
    if (scrollY <= threshold) {
      return initialOpacity
    } else if (scrollY >= threshold + fadeDistance) {
      return 0
    } else {
      const progress = (scrollY - threshold) / fadeDistance
      return initialOpacity * (1 - progress)
    }
  }
}

// Optimized scroll handler using requestAnimationFrame
export function createScrollHandler(callback: (scrollY: number) => void) {
  let ticking = false

  return () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        callback(window.scrollY)
        ticking = false
      })
      ticking = true
    }
  }
}

// Check if user prefers reduced motion
export function prefersReducedMotion(): boolean {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches
}
